export default [
  {
    title: 'Analytics',
    icon: 'PieChartIcon',
    children: [
      {
        title: 'Reports',
        route: 'apps-analytics-reports',
        icon: 'FileTextIcon',
      },
      {
        title: 'Sales Report',
        route: 'sales-report',
        icon: 'FileTextIcon',
      },
      {
        title: 'Purchase Report',
        route: 'purchase-report',
        icon: 'ShoppingBagIcon',
      },
      {
        title: 'Inventory Report',
        route: 'inventory-report',
        icon: 'BarChartIcon',
      },
    ],
  },
];
